/**
 * Wpis historii pracy dotyczący strefy alarmowej → klucz tłumaczenia z sekcji WORK-HISTORY.
 *
 * Backend rozbija część operacji na czasownik w `action` i nazwę obszaru w `parameter`
 * (`delete` + `alarm_zone`), a część zapisuje w jednym kodzie (`alarm_zone_update`).
 * W pierwszym przypadku sam kod akcji nie mówi o strefie nic — wpis opisywał się wtedy
 * zdaniem o usunięciu użytkownika o numerze IMEI „alarm_zone" (błąd 415). Dlatego
 * rozpoznajemy strefę w obu polach naraz.
 *
 * Czyste funkcje, bez zależności od Angulara — testują się bez TestBed.
 */

/** Kolejność bez znaczenia: wpis niesie tylko jeden czasownik. */
const VERBS: Array<{ verb: string, pattern: RegExp }> = [
  { verb: 'ADD', pattern: /add|create/ },
  { verb: 'EDIT', pattern: /edit|update|change|modify/ },
  { verb: 'DELETE', pattern: /delete|remove/ }
];

/**
 * Dwa „zone", które strefą alarmową nie są: strefa czasowa oraz odebrany alarm wyjścia
 * ze strefy. Ta sama lista rządzi ikoną wiersza w obu widokach historii pracy.
 */
const NOT_ALARM_ZONE = ['leavezone', 'leave_zone', 'outzone', 'out_of_zone'];

/** Sama nazwa obszaru — do kolumny „Szczegóły" i do wpisów bez czytelnego czasownika. */
export const ALARM_ZONE_LABEL_KEY = 'WORK-HISTORY.ALARM-ZONE';

/**
 * Strefa alarmowa (geofence) z konfiguracji opaski. Bierze zarówno kod akcji, jak
 * i wartość `parameter` — w obu miejscach nazwa obszaru wygląda tak samo.
 */
export function isAlarmZoneAction(value: string): boolean {
  const a = (value || '').toString().toLowerCase().replace(/time[ _-]?zone/g, '');
  if (a.indexOf('zone') === -1) { return false; }
  return !NOT_ALARM_ZONE.some(token => a.indexOf(token) !== -1);
}

/**
 * `null` = wpis nie dotyczy strefy alarmowej; wtedy wywołujący zostaje przy swoim
 * dotychczasowym zachowaniu.
 */
export function toAlarmZoneActionKey(action: string, parameter?: string): string {
  if (!isAlarmZoneAction(action) && !isAlarmZoneAction(parameter)) {
    return null;
  }
  const verb = toVerb(action) || toVerb(parameter);
  return verb ? 'WORK-HISTORY.ALARM-ZONE-' + verb : ALARM_ZONE_LABEL_KEY;
}

function toVerb(value: string): string {
  const a = (value || '').toString().toLowerCase();
  const matched = VERBS.filter(candidate => candidate.pattern.test(a))[0];
  return matched ? matched.verb : null;
}
